import React, { useCallback } from "react";
import * as d3 from "d3";
import { LineChartDatas } from "@evergis/charts";

import { ColorBox, Tooltip, TooltipFlex, TooltipTitle } from "../styled";

export const useRenderLineTooltip = () => {
  const format = d3.format(",");

  return useCallback(
    (datas, { indexX }, labels) => {
      const title = labels[indexX];

      return (
        <Tooltip>
          <TooltipTitle>{title}</TooltipTitle>
          {datas.map(({ invertValue, stroke, fill }: LineChartDatas, dataIndex: number) => (
            <TooltipFlex key={`tooltip-container-${dataIndex}`}>
              <ColorBox color={stroke || fill} />
              {format(Number(invertValue.toFixed(2)))}
            </TooltipFlex>
          ))}
        </Tooltip>
      );
    },
    [format],
  );
};
